'use client';
import React, { useState } from 'react';
import { Text, Box, Image, Center, Grid, GridItem } from '@chakra-ui/react';

function PreviousWork({}) {
  const heading = {
    fontSize: { base: '6vw', md: '2vw' },
    fontWeight: 700,
    color: 'white',
  };
  const headText = {
    fontSize: { base: '4vw', md: '1vw' },
    textAlign: 'center',
    color: 'white',
    padding: { base: '0 3vw 0vw', md: '0' },
  };
  const [mainImageSrc, setMainImageSrc] = useState('/images/gym/gym_13.jpg');

  const handleThumbnailHover = (newSrc) => {
    console.log('Hovered over thumbnail : ' + newSrc);
    setMainImageSrc(newSrc);
  };

  const container = {
    bg: '#2e2925',
    color: '#ffffff',
    padding: '3vw 0 0 0',
  };
  const showcaseContainer = {
    display: 'grid',
    gridTemplateColumns: { base: '1fr', md: '2fr 1fr' }, // Left side is larger than the right
    height: '100%',
    gap: { base: '1vw', md: '2vw' },
    padding: '0 5vw',
    bg: '#2e2925',
    paddingTop: '3vw',
  };
  const gridContainerStyle = {
    templateColumns: { base: 'repeat(4, 1fr)', md: 'repeat(3, 1fr)' }, // 6 columns on small screens, 3 on medium and larger
    gap: { base: '2vw', md: '1vw' }, // Gap between the grid items
    alignItems: 'start', // Ensure items are aligned at the top
    gridAutoRows: 'min-content', // Prevent rows from expanding unnecessarily
  };

  const thumbnailStyle = {
    cursor: 'pointer',
    width: '100%',
    height: 'auto',
    borderRadius: { base: '2.5vw', md: '1vw' },
  };

  const mainImageStyle = {
    objectFit: 'cover',
    width: '100%',
    height: 'auto',
    display: 'block',
    borderRadius: { base: '5vw', md: '2vw' }, // Rounded corners for the main image
  };

  return (
    <>
      <Box {...container} padding={{ base: '3vw', md: '0' }}>
        <Center {...heading}>See our Previous Work</Center>
        <Center {...headText}>
          Browse our portfolio to find inspiration from our work with satisfied
          customers.
        </Center>
        {/* <Center {...headText}>
          happy customers and get inspired for your own project!
        </Center> */}
      </Box>
      <Box {...showcaseContainer}>
        <Box width="100%" marginBottom="2vw">
          <Image
            src={mainImageSrc}
            alt="Mirrorworld Gym Mirrors showcase 1"
            {...mainImageStyle}
          />
        </Box>

        <Grid {...gridContainerStyle}>
          {[
            '/images/gym/gym_13.jpg',
            '/images/gym/gym_12.jpg',
            '/images/gym/gym_11.jpg',
            '/images/gym/gym_10.jpg',
            '/images/gym/gym_09.jpg',
            '/images/gym/gym_08.jpg',
            '/images/gym/gym_07.jpg',
            '/images/gym/gym_06.jpg',
            '/images/gym/gym_05.jpg',
            '/images/gym/gym_04.jpg',
            '/images/gym/gym_03.jpg',
            '/images/gym/gym_02.jpg',
            '/images/gym/gym_01.jpg',
          ].map((src, index) => (
            <Box key={index}>
              <Image
                src={src}
                alt={`Mirrorworld Gym Mirrors showcase ${index + 1}`}
                {...thumbnailStyle}
                onMouseOver={() => handleThumbnailHover(src)} // Update main image on hover
              />
            </Box>
          ))}
        </Grid>
      </Box>
    </>
  );
}

export default PreviousWork;
